module.exports = __webpack_public_path__ + "img/magnifying_glass.3551e205.png";